// @ts-ignore
import {GoogleAnalyticsCode} from 'google.analytics';
import {sprintf} from 'sprintf-js';

const appId = 'UA-141690197-1';
const title = 'UBC JobCorps';
declare const dataLayer: GoogleAnalyticsCode;

function gtag() {
    try {
        ((window as any).dataLayer || []).push(arguments);
    } catch (e) {
        console.warn(e);
    }
}

// @ts-ignore
gtag('js', new Date());

export function trackPage(path: string) {
    // console.log(sprintf('Logging Google Analytics for %s (%s)', title, path));
    // @ts-ignore
    gtag('config', appId, {
        page_title: title,
        page_path: path
    });
}
